
<template>
  <div>
    <div :id="name"></div>
  </div>
</template>

<script>
export default {
  props: ["value", "placeholder","name"],
  data: function() {
    return {
      session: this.$session.get("jwt")
    };
  },
  beforeCreate() {
  },
  created(){

  },
  mounted(){
    let vm = this;
    $(`#${this.name}`).summernote({
        placeholder: vm.placeholder,
        tabsize: 2,
        height: 150,
        callbacks: {
            onChange: function(contents, $editable) {
              vm.$emit('input', contents);
          },
            onInit: function() {
              $(`#${vm.name}`).summernote('code',vm.value)
          },
            onBlur: function(contents, $editable) {
              // vm.$emit('change', contents);
          },
            onImageUpload: function(files) {
              vm.upload(files);
            }
        }
      });
  },
  methods: {
    upload(files){
      const data = new FormData();
      data.append("upload", files[0]);
          this.$store
              .dispatch("uploadAws", data)
              .then(response => {
                var image = $('<img>').attr('src', response.data.data.default);
                $(`#${this.name}`).summernote('insertNode', image[0]);
              })
              .catch(error => {
                this.$swal({
                  type: "error",
                  title: "Oops...",
                  text: error.response.data.message,
                  showConfirmButton: false,
                  timer: 1500
                });
                console.log(error);
              });
    }
  }
};
</script>

<style>
</style>